/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import FormControlLabel from '@material-ui/core/FormControlLabel';
import React from 'react';
import { Trans } from 'react-i18next';
import CustomCheckbox from '../../../CustomCheckbox';
import { StyledTableCell } from './StyledTableCell';
import Tooltip from '../../../common/Tooltip';

export function FeeCheckboxCell({ fee, checked, disabled, onClick, onBlur, disabledTooltip }) {
  return (
    <StyledTableCell>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          label={fee.code}
          title={checked ? fee.tooltip : ''}
          disabled={disabled}
          control={
            disabled && disabledTooltip ? (
              <Tooltip noSpacing title={<Trans i18nKey={disabledTooltip} />}>
                <span>
                  <CustomCheckbox
                    id={`${fee.code}-fees-checkbox`}
                    checked={checked}
                    disabled={disabled}
                    onClick={onClick}
                    onBlur={onBlur}
                  />
                </span>
              </Tooltip>
            ) : (
              <CustomCheckbox
                id={`${fee.code}-fees-checkbox`}
                checked={checked}
                disabled={disabled}
                onClick={onClick}
                onBlur={onBlur}
              />
            )
          }
        />
      </div>
    </StyledTableCell>
  );
}
